/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type StorefrontProductGrid_user = {
    readonly serviceId: string | null;
    readonly " $fragmentRefs": FragmentRefs<"StorefrontProductTile_user">;
    readonly " $refType": "StorefrontProductGrid_user";
};
export type StorefrontProductGrid_user$data = StorefrontProductGrid_user;
export type StorefrontProductGrid_user$key = {
    readonly " $data"?: StorefrontProductGrid_user$data;
    readonly " $fragmentRefs": FragmentRefs<"StorefrontProductGrid_user">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "StorefrontProductGrid_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "StorefrontProductTile_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};
(node as any).hash = 'afdf0ee6cbdf3256b81521631216ee4f';
export default node;
